import React from "react";
import PermissionGate from "../../services/PermissionGate";
import { CaixaProvider } from "../../contexts/caixaContext";
import CaixaComponent from "./CaixaComponent";

const Caixa = () => {
  return (
    <>
      <PermissionGate permissions={["default"]}>
        {/*<LeftMenu setSidebar={setSidebar} sidebar={sidebar} />*/}
        <CaixaProvider>
          <CaixaComponent />
        </CaixaProvider>
      </PermissionGate>
    </>
  );
};

export default Caixa;
